<template>
  <div class="row">

    <!--
    <div v-if="invoiceId" data-notify="container" class="col-md-12 alert alert-success alert-with-icon">
      <span data-notify="icon" class="fa fa-file-text-o"></span>
      <div data-notify="message">Payment complete, invoice <router-link :to="'/credit/history/' + invoiceId" style="color: inherit; text-decoration: underline">{{invoiceId}}</router-link> has been saved to your invoices history.</div>
    </div>
    -->

    <transition name="el-fade-in-linear" mode="out-in">

      <div key="View" v-if="verificationId">
        <verification-view :id="verificationId" :inner="true" :result="result" />
        <div class="col-md-12 card card-plain">
          <button @click.prevent="verificationId = null; result = null; getHistory()" type="button" class="btn btn-wd btn-fill btn-move-left"><span class="btn-label"><i class="ti-angle-left"></i></span> Back</button>
        </div>
      </div>
      
      <div key="History" v-else class="col-md-12 card">
        <div class="card-header">
          <h4 class="card-title">History</h4>
          <div class="category">Past verifications requested {{$store.state.isIndividual ? '' : 'by you and your team'}}</div>
        </div>
        <div class="card-content row form-horizontal">
          <div class="filters form-group" style="margin-left: 0">
            <transition name="el-fade-in-linear" mode="out-in">
              <div key="filtersClose" v-if="!filtersOpen">
                <div class="col-sm-10">
                  <el-input :placeholder="placeholder" prefix-icon="el-icon-search" v-model="query" :clearable="true" style="width: 100% !important"></el-input>
                </div>
                <div class="col-sm-2">
                  <button @click.prevent="filtersOpen = true" class="btn btn-fill btn-wd btn-default pull-right"><i class="fa fa-filter"></i>&nbsp;Filters {{filtersCount}}</button>
                </div>
              </div>
              <div key="filtersOpen" v-else="filtersOpen" class="col-sm-12 card-plain">
                <div class="el-collapse">
                  <div class="el-collapse-item is-active">
                    <div role="tab" style="margin-bottom: 15px">
                      <div @click="filtersOpen= false" role="button" class="el-collapse-item__header pull-right">
                        <i class="fa fa-times pull-right"></i>
                      </div>
                    </div>
                    <div role="tabpanel" class="el-collapse-item__wrap">
                      <div class="el-collapse-item__content"> 
                        <div class="form-horizontal">
                          <div class="form-group">
                            <label class="col-sm-2 control-label">Name or QCID</label>
                            <div class="col-sm-10">
                              <el-input placeholder="All" prefix-icon="el-icon-search" v-model="query" :clearable="true"></el-input>
                              <span class="help-block">Search by first, last or full name, or by QCID.</span>
                            </div>
                          </div>
                                                    
                          <div v-if="!$store.state.isIndividual" class="form-group">
                            <label class="col-sm-2 control-label">Requested By</label>
                            <div class="col-sm-10">
                              
                              <user-select v-model="requestedBy" :includePending="false" />
                              <span class="help-block">Search by the user who submitted the requested.</span>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-2 control-label">Date</label>
                            <div class="col-sm-10">
                              <el-date-picker
                                v-model="dateRange"
                                type="daterange"
                                size="large"
                                :editable="false"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                value-format="yyyy-MM-dd"
                                :default-value="defaultDate"
                                :picker-options="pickerOptions">
                              </el-date-picker>
                              <span class="help-block">Show only verifications on or between these dates.</span>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-2 control-label">Result</label>
                            <div class="col-sm-10">
                              <el-select multiple
                                        v-model="internalResults"
                                        :clearable="true"
                                        placeholder="All">
                                <el-option value="INCOMPLETE" label="Incomplete" />
                                <el-option value="ACTION" label="Action Required" />
                                <el-option value="VERIFIED" label="Verified" />
                                <el-option value="NOT_VERIFIED" label="Not Verified" />
                                <el-option value="PENDING" label="Pending" />
                                <el-option value="CANCELLED" label="Cancelled" />
                                <el-option value="UNABLE" label="Delayed at Source" />
                                <el-option v-if="this.$store.state.showDeleted" value="DELETED" label="Deleted" />
                              </el-select>
                              <span class="help-block">Select multiple results or <a @click.prevent="clearResults" href="#">clear</a> for all results.</span>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-2 control-label">Type</label>
                            <div class="col-sm-10">
                              <el-select multiple
                                        v-model="types"
                                        :clearable="true"
                                        placeholder="All">
                                <el-option value="edu" label="Education" />
                                <el-option value="emp" label="Employment" />
                                <el-option value="idc" label="Identity" />
                              </el-select>
                              <span class="help-block">Select multiple types or <a @click.prevent="clearTypes" href="#">clear</a> for all types.</span>
                            </div>
                          </div>
                          
                          <div class="form-group">
                            <label class="col-sm-2 control-label">{{$store.getters.refLabel}}</label>
                            <div class="col-sm-10">
                              <el-input placeholder="All" prefix-icon="el-icon-search" v-model="customerReference" :clearable="true"></el-input>
                              <span class="help-block">Search by the reference number or key used to track this case in your internal system, if you have one.</span>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-2 control-label"></label>
                            <div class="col-sm-10">
                              <button @click.prevent="clearFilters" class="btn btn-default btn-fill btn-wd">Clear All</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <verification-history-table
            :query="query"
            :requestedBy="requestedByName"
            :customerReference="customerReference"
            :results="results"
            :types="types"
            :dateRange="dateRange"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import View from 'src/views/Verifications/View'
  import VerificationHistoryTable from 'src/views/Verifications/components/VerificationHistoryTable'

  import {DatePicker} from 'element-ui'

  import UserSelect from 'src/components/Inputs/UserSelect'

  import moment from 'moment'
  import _ from 'lodash'

  export default {
    name: "verification-history",
    components: {
      [DatePicker.name]: DatePicker,
      UserSelect,
      'verification-view': View,
      'verification-history-table': VerificationHistoryTable
    },
    data () {
      return {
        verificationId: null,
        placeholder: "Search by name, QCID or " + this.$store.getters.refLabel, 
        result: null,
        invoiceId: null,
        query: "",
        requestedBy: "",
        customerReference: "",
        internalResults: [],
        results: [],
        types: [],
        dateRange: [],
        filtersOpen: false,
        pickerOptions: {
          disabledDate (date) {
            return date > new Date()
          },
          shortcuts: [
            {
              text: 'Last week',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: 'Last month',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: 'Last 3 months',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        }
      }
    },
    mounted () {
      if(this.$route.query.invoiceId) {
        this.invoiceId = this.$route.query.invoiceId
      }
      if(this.$route.query.result) {
        this.internalResults = []
        this.internalResults.push(this.$route.query.result)
      }
    },
    activated () {
      if(this.$route.query.invoiceId) {
        this.invoiceId = this.$route.query.invoiceId
      }
      if(this.$route.query.result) {
        this.internalResults = []
        this.internalResults.push(this.$route.query.result)
      }
    },
    watch: {
      internalResults: _.debounce(function  (value) {
        var newResults = []
        value.forEach(function (result) {
          if(result === 'ACTION') {
            newResults.push('NOT_FOUND')
            newResults.push('REJECTED')
          } else if(result === 'INCOMPLETE') {
            newResults.push('UNPAID')
            newResults.push('AWAITING_CONSENT')
          } else {
            newResults.push(result)
          }
        })
        this.results = newResults
      }, 0),
      dateRange(value) {
        if(value == null) {
          this.dateRange = []
        }
      }
    },
    computed: {
      requestedByName() {
        return this.requestedBy
      },
      filtersCount () {
        var count = 0
        if(this.query) count++
        if(this.requestedBy) count++
        if(this.customerReference) count++
        if(this.dateRange.length > 0) count++
        if(this.results.length > 0) count++
        if(this.types.length > 0) count++
        return count > 0 ? "(" + count + ")" : ""
      },
      defaultDate() {
        return moment().subtract(1, 'months').format('YYYY-MM-DD');
      }
    },
    methods: {
      filtersChange (activeNames) {
        var _this = this;
        setTimeout(function () {
          _this.filtersOpen = activeNames.includes("open")
        }, 0);
      },
      clearResults () {
        this.results = []
        this.internalResults = []
        this.$store.commit('setHistoryFilters', {results: []})
      },
      clearTypes () {
        this.types = []
      },
      clearFilters () {
        this.query = ""
        this.requestedBy = ""
        this.customerReference = ""
        this.results = []
        this.internalResults = []
        this.types = []
        this.dateRange = []
        this.$store.commit('clearHistoryFilters', null)
      }
    }
  }
</script>
<style>

</style>
